export default __webpack_public_path__ + "static/566-6fbb06382a922e88b020eba278221783.gif";